import { GlowUpManagement } from '@/components/glow-up/GlowUpManagement';

export const GlowUpPage = () => {
  return <GlowUpManagement />;
};
